import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/core/users'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      name: null,
      email: null,
      status: null,
      id_user_types: null,
      secret_files: null,
      password: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    forgotResult: {
      message: null,
      status: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    getForgotResult(state) {
      return state.forgotResult
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        name: null,
        email: null,
        status: null,
        id_user_types: null,
        secret_files: null,
        password: null,
      }
    },
    AUTH_FORGOT(state, data) {
      state.forgotResult = data
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          select: [
            'users.id AS id',
            'users.name AS name',
            'users.email AS email',
            'users.status AS status',
            'users.id_user_types AS id_user_types',
            'users.secret_files AS secret_files',
          ],
          where: {
            'users.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    forgotPassword({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post('/Auth/forgot', data)
        .then(response => {
          commit('AUTH_FORGOT', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
